import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'calsoft-crm-comparison',
  templateUrl: './crm-comparison.component.html',
  styleUrls: ['./crm-comparison.component.scss'],
  animations: [
    trigger('slideAnimation', [
        state('collapsed', style({ height: '0', opacity: 0 })),
        state('expanded', style({ height: '*', opacity: 1 })),
        transition('collapsed <=> expanded', [
            animate('400ms cubic-bezier(0.4, 0, 0.2, 1)')
        ])
    ]),
    trigger('fadeAnimation', [
        state('visible', style({ opacity: 1 })),
        state('hidden', style({ opacity: 0 })),
        transition('visible <=> hidden', [
            animate('300ms ease-in-out')
        ])
    ])
]
})
export class CrmComparisonComponent implements OnInit {
  @Input() img: any; 
  @Input() item: any;
  @Input() data: any;
   public serverPath = environment.commonImageApi + '/commonSlider/';
  
    public serverPath1 = environment.commonImageApi + '/home/';
  

  selectedProduct: any; 
  ourCRM: any;
  ComparisonList: any[] = [];
  dropdownOpen = false;
  numUsers = 100; 
  isDropdownOpen = false;

  ngOnInit(): void {
    if (this.img && this.img.length > 0) {
      this.ourCRM = this.transformData(this.img[0]); 
      this.ComparisonList = this.img.slice(1).map(item => this.transformData(item)); 
      this.selectedProduct = this.ComparisonList[0]; 
    }
  }
  transformData(data: any) {
    return {
      name: data.customField10,
      details: data.customField11, 
      pricePerUser: Number(data.customField12), 
      totalPrice: Number(data.customField12) * this.numUsers, 
    };
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectProduct(product: any) {
    this.selectedProduct = product;
    this.dropdownOpen = false;
  }

  
  get selectedCRMTotalPrice() {
    return this.selectedProduct?.pricePerUser * this.numUsers;
  }

  get ourCRMTotalPrice() {
    return this.ourCRM?.pricePerUser * this.numUsers;
  }

  get savings() {
    return Math.abs(this.ourCRMTotalPrice - this.selectedCRMTotalPrice);
  }
  
  get savingsPercentage() {
    const higherPrice = Math.max(this.ourCRMTotalPrice, this.selectedCRMTotalPrice);
    return higherPrice > 0 ? Math.round((this.savings / higherPrice) * 100) : 0;
  }
  
  showTable: boolean = false;

  toggleTable() {
    this.showTable = !this.showTable;
    setTimeout(() => {
      document.querySelector('.crm-table')?.classList.toggle('show', this.showTable);
    }, 10);
  }


}